//import {CSSInterpolation} from '@emotion/css';

import { merge } from 'Shared/common/merge';
import { ITheme } from 'Shared/ITheme';
import { theme } from 'Shared/ThemeProvider';

const button = {
	textAlign: 'center',
	verticalAlign: 'middle',
	backgroundColor: '#7e94a5',
	borderRadius: 3,
	border: '1px solid #728a9d',
	color: '#FFF',
	padding: '8px 12px',
	fontSize: 13,
	fontWeight: 400,
	lineHeight: '16px',
	cursor: 'pointer',
};

export function artistTheme()
{
//	return merge(theme(), {
	return {
		root: {
			font: '15px "Open Sans",Helvetica,Arial,sans-serif',
			backgroundColor: 'white',
			color: 'black'
		},

	//XXX some of these arent used - copied from venues backend. CAN we use types to track these down?
		palette: {
			background: 'grey',
			dimBackground: '#f5f5f5',   //XXX alt name - could be 'shaded'
			text: 'black', 
			dimText: '#aaa',		// e.g. disabled
			borderBackgroundColour: '#1b2126',
			subHeaderBackground: '#fafafa',
			label: '#666',
			active: '#44C4A1',
			inactive: 'lightgrey',
			link: '#005394',
			error: '#ff0101'
		},

		content: {
			margin: '1em auto',
			maxWidth: 700,
			border: '1px solid #ddd',
			padding: '2em 2em',
		},

		nav: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginBottom: '3em',
		},

		h3: {
			fontSize: '1.2em',
			color: '#42627b',
			lineHeight: '1.5em',
			textTransform: 'uppercase',
			textAlign: 'left',
			fontWeight: 'initial'
		},

		h4: {
			textTransform: 'uppercase',
			color: '#000000',
			fontSize: '1em',
			margin: '12px 0 6px 0',
			padding: 6
		},

		section: {
			margin: '0 0 36px 0'
		},

		button: button,

		smallButton: {...button,
			padding: '6px 0.6em',
			fontSize: '0.7em'
		},

		a: {
			textDecoration: 'none',
			color: '#005394',
			cursor: 'pointer',

			'&:visited': {
				color: '#005394'
			}
		},

		linkIcon: {
			width: '2em'
		}
	} satisfies ITheme;
};

